import { TextLogo } from '@packages/shared-ui/components';
import { brandColors } from '@/styles/theme/values/brandColors';
import useStyles from './CallToActionScreen.styles';
import type { CallToActionScreenData } from './InteractiveQuoteForm';
import InteractiveQuoteFormFooter from './InteractiveQuoteFormFooter';
import { VideoGrid } from './VideoGrid';

interface CallToActionScreenProps {
  data: CallToActionScreenData;
}

/**
 * @deprecated V2 component
 */
export default function CallToActionScreen({
  data: { heading, subheading, formContent, videos, fullScreenImage, footer },
}: CallToActionScreenProps) {
  if (footer)
    footer.fields.textColor = fullScreenImage
      ? brandColors.white
      : brandColors.primaryMain;
  const { classes } = useStyles();
  return (
    <div
      className={classes.page}
      style={{ backgroundImage: `url(${fullScreenImage})` }}
    >
      <div className={classes.container}>
        <div className={classes.contentContainer}>
          <div className={classes.logo}>
            <TextLogo color={brandColors.primaryMain} width='95' />
          </div>
          <div className={classes.formContainer}>
            <div>
              <h1 className={classes.heading}>{heading}</h1>
              <h2 className={classes.subheading}>{subheading}</h2>
            </div>
            <form>{formContent}</form>
          </div>
        </div>
        <div className={classes.rightHalfContainer}>
          {videos && <VideoGrid videos={videos} />}
        </div>
      </div>
      {footer && <InteractiveQuoteFormFooter content={footer} />}
    </div>
  );
}
